import { IRoute } from '../interfaces/routing';
import loadable from '@loadable/component';

// import EditAccountPage from '../pages/services/EditAccounPage';
// import BasicProfilePage from '../pages/services/BasicProfilePage';
// import AddressDetailsPage from '../pages/services/AddressDetailsPage';
// import EducationDetailsPage from '../pages/services/EducationDetailsPage';
// import BankDetailsPage from '../pages/services/BankDetailsPage';
// import ProfileDetailsPage from '../pages/services/ProfileDetailsPage';
// import AddTimingPage from '../pages/dashboards/ConsultantDashboard/AddTiming/AddTimingPage';
// import CertificateDetailPage from '../pages/services/CertificateDetailPage';
// import MyBookingPage from '../pages/dashboards/ConsultantDashboard/Mybooking/MyBookingPage';
// import ChangePasswordPage from '../pages/dashboards/ConsultantDashboard/ChangePassword/ChangePasswordPage';
// import ConsultantMyProfilePage from '../pages/dashboards/ConsultantDashboard/MyProfile/ConsultantMyProfile';
// import Room from '../pages/components/Room/Room';
// import AddConsultantComplaintPage from '../pages/dashboards/ConsultantDashboard/Complaint/AddConsultantComplaintPage';
// import ViewConsultantComplaintPage from '../pages/dashboards/ConsultantDashboard/Complaint/ViewConsultantComplaintPage';
// import ViewConsultantComplaintAgainstPage from '../pages/dashboards/ConsultantDashboard/Complaint/ViewConsultantComplainstAgainstPage';
// import ViewCertificateDetailsPage from '../pages/services/AddCertificate';
// import EditCertificateForm from '../pages/services/EditCertificatePage';
// import AddNotePage from '../pages/dashboards/ConsultantDashboard/Mybooking/AddNotePage';
// import ConsultantDashboardPage from '../pages/dashboards/dashboard/ConsultantDashboard';
// import DocumentPage from '../pages/services/DocumentPage';

const EditAccountPage = loadable(() => import ('../pages/services/EditAccounPage'));
const BasicProfilePage = loadable(() => import ('../pages/services/BasicProfilePage'));
const AddressDetailsPage = loadable(() => import ('../pages/services/AddressDetailsPage'));
const EducationDetailsPage = loadable(() => import ('../pages/services/EducationDetailsPage'));
const ProfileDetailsPage = loadable(() => import ('../pages/services/ProfileDetailsPage'));
const AddTimingPage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/AddTiming/AddTimingPage'));
const CertificateDetailPage = loadable(() => import ('../pages/services/CertificateDetailPage'));
const MyBookingPage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/Mybooking/MyBookingPage'));
const ChangePasswordPage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/ChangePassword/ChangePasswordPage'));
const ConsultantMyProfilePage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/MyProfile/ConsultantMyProfile'));
const Room = loadable(() => import ('../pages/components/Room/Room'));
const AddConsultantComplaintPage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/Complaint/AddConsultantComplaintPage'));
const ViewConsultantComplaintPage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/Complaint/ViewConsultantComplaintPage'));
const ViewConsultantComplaintAgainstPage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/Complaint/ViewConsultantComplainstAgainstPage'));
const ViewCertificateDetailsPage = loadable(() => import ('../pages/services/AddCertificate'));
const EditCertificateForm = loadable(() => import ('../pages/services/EditCertificatePage'));
const AddNotePage = loadable(() => import ('../pages/dashboards/ConsultantDashboard/Mybooking/AddNotePage'));
const ConsultantDashboardPage = loadable(() => import ('../pages/dashboards/dashboard/ConsultantDashboard'));
const DocumentPage = loadable(() => import ('../pages/services/DocumentPage'));

export const consulatntRoutes: IRoute[] = [
    {
        path: 'dashboard',
        component: ConsultantDashboardPage
    },
    {
        path: 'my-profile',
        component: ConsultantMyProfilePage
    },
    {
        path: 'edit-account',
        component: EditAccountPage
    },
    {
        path: 'edit-account/basic-profile',
        component: BasicProfilePage
    },
    {
        path: 'edit-account/address-detail',
        component: AddressDetailsPage
    },
    {
        path: 'edit-account/education-detail',
        component: EducationDetailsPage
    },
    // {
    //     path: 'edit-account/bank-detail',
    //     component: BankDetailsPage
    // },
    {
        path: 'edit-account/profile-detail',
        component: ProfileDetailsPage
    },
    {
        path: 'edit-account/document',
        component: DocumentPage
    },
    {
        path: 'add-complaint',
        component: AddConsultantComplaintPage
    },
    {
        path: 'view-complaint-by-me',
        component: ViewConsultantComplaintPage
    },
    {
        path: 'view-complaint-against',
        component: ViewConsultantComplaintAgainstPage
    },
    {
        path: 'add-timing',
        component: AddTimingPage
    },
    {
        path: 'my-booking',
        component: MyBookingPage
    },
    {
        path: 'my-booking/add-note/:sessionId?/:clientId?',
        component: AddNotePage
    },
    {
        path: 'change-password',
        component: ChangePasswordPage
    },
    {
        path: 'edit-account/certificate-detail',
        component: CertificateDetailPage,
    },
    {
        path: 'edit-account/certificate-detail/all-certificate',
        component: CertificateDetailPage,
    },
    {
        path: 'edit-account/add-certificate',
        component: ViewCertificateDetailsPage
    },
    {
        path: 'edit-account/certificate-detail/edit/:id',
        component: EditCertificateForm
    },
    {
        path: 'room/:roomid',
        component: Room
    }
];
